import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import endpoints from '../../../environment/endpoints';
import FetchService from '../../../services/FetchService';
import MashListManage from './mashlist-manage';
import MashListView from './mashlist-view';

const fetchService = new FetchService();

export default function MashListRouter({ mode: initialMode }: { mode?: string }) {
    const params = useParams();
    const shortkey = params.shortkey || params.id;

    const [mashListId, setMashListId] = useState<string | undefined>(initialMode ? params.id : undefined);
    const [mode, setMode] = useState(initialMode || '');

    const fetchShortKey = useCallback(async () => {
        const res = await fetchService.get(endpoints.getShortKey, shortkey);
        if (res.success && res.data?.mashListId) {
            setMashListId(res.data.mashListId);
            setMode('view');
        }
    }, [shortkey]);

    useEffect(() => {
        if (!initialMode && shortkey) {
            fetchShortKey();
        }
    }, [shortkey, fetchShortKey, initialMode])

    if (!mashListId) {
        return null;
    }

    if (mode === 'manage') {
        return <MashListManage id={mashListId} />;
    }

    return <MashListView id={mashListId} />;
};